export const psColumns = [
  {
    header: 'Campaign Type',
    accessor: 'is_brand',
    transform: (value) => (value === 0 ? 'Non-Brand' : 'Brand'),
  },
  {
    header: 'Clicks',
    accessor: 'clicks',
  },
  {
    header: 'Impressions',
    accessor: 'impressions',
  },
  {
    header: 'CTR',
    accessor: 'ctr',
    unit: '%',
  },
  {
    header: 'CPC',
    accessor: 'cpc',
    unit: '$',
  },
  {
    header: 'Spend',
    accessor: 'cost',
    unit: '$',
  },
  {
    header: 'Search Impression Share',
    accessor: 'search_impr_share',
    unit: '%',
  },
  {
    header: 'Opportunities',
    accessor: 'opps',
  },
  {
    header: 'Opps Won',
    accessor: 'opps_closed',
    unit: 'trunc',
  },
  {
    header: 'Opps Planned',
    accessor: 'opps_plan',
    unit: 'trunc',
  },
  {
    header: 'CPO',
    accessor: 'cpo',
    unit: '$',
  },
  {
    header: 'CPO Planned',
    accessor: 'cpo_plan',
    unit: '$',
  },
  {
    header: 'Revenue Generated',
    accessor: 'revenue',
    unit: '$',
  },
  {
    header: 'ROMI',
    accessor: 'romi',
    unit: '$',
  },
];
